import { Component } from '@angular/core';

@Component({
    selector: 'question',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class QuestionComponent {}
